module.exports = __webpack_public_path__ + "static/media/guiaNar.fcee2b79.png";